<template>
  <div>
    <div class="container-fluid my-account">
      <div class="row">
        <div class="col-md-12 page_title">My Orders</div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div
              class="success_message"
              v-text="this.$root.success_message"
              v-if="this.$root.success_message != ''"
          ></div>
          <div
              class="error_message"
              v-text="this.$root.error_message"
              v-if="this.$root.error_message != ''"
          ></div>
        </div>
        <div class="col-md-2 account_sidebar">
          <ul class="sidebar">
            <li class="sidebar_list active">
              <router-link :to="{ name: 'dashboard' }">Overview</router-link>
            </li>
            <li class="sidebar_list">
              <h4 class="sidebar_heading">Orders & returns</h4>
              <router-link :to="{ name: 'order' }">My Orders</router-link>
            </li>
            <li class="sidebar_list">
              <h4 class="sidebar_heading">Account</h4>
              <router-link :to="{ name: 'profile' }">Profile</router-link>
              <!-- <router-link :to="{name:'address_book'}">Saved Cards</router-link> -->
              <router-link :to="{ name: 'address_book' }">Address</router-link>
            </li>
            <li class="sidebar_list">
              <h4 class="sidebar_heading">Credits</h4>
              <router-link :to="{ name: 'StoreCredit' }"
              >WNDW Credits</router-link
              >
            </li>
          </ul>
        </div>

          <div class="orderPageSkeleton col-md-10" v-if="orderLoader">
        <PuSkeleton  class=" Skeleton1"  width="100%" height="inherit"   />
        <PuSkeleton  class=" Skeleton2"  width="100%" height="inherit"   />
          </div>
        <div class="col-md-10 account_detail" v-else>
          <div class="row">
            <div class="col-md-12">
              <p v-if="order.length == 0">No Order found</p>
              <div
                  class="newOrderWrap row"
                  v-for="(items, i) in order"
                  :key="i"
              >
                <div class="newOrderStatus">
                  <div class="orderIconImg">
                    <img
                        src="/img/order-ico.png"
                        class="img-fluid"
                        alt="Order Icon"
                    />
                  </div>
                  <span class="ml-3">{{ items.order_increment_id }}</span>

                  <div
                      class="newOrderDetails"
                      style="margin-left: 45px !important"
                  >
                    <p>{{ items.order_id }}</p>
                    <p
                        class="orderStatus"
                        :class="
                        items.order_status == 'delivered'
                          ? 'delivery'
                          : '' || items.order_status == 'pending'
                          ? 'pending'
                          : '' || items.order_status == 'accepted'
                          ? 'delivery'
                          : '' || items.order_status == 'rejected'
                          ? 'return'
                          : '' || items.order_status == 'ready_for_shipment'
                          ? 'inProcess'
                          : '' || items.order_status == 'return_in_process'
                          ? 'inProcess'
                          : '' || items.order_status == 'returned'
                          ? 'delivery'
                          : '' || items.order_status == 'cancelled'
                          ? 'return'
                          : '' || items.order_status == 'item_returned_to_store'
                          ? 'inProcess'
                          : '' || items.order_status == 'return_rejected'
                          ? 'return'
                          : ''
                          || items.order_status == 'return_accepted'
                          ? 'delivery'
                          : ''
                          || items.order_status == 're_delivery_in_process'
                          ? 'inProcess'
                          : ''
                          || items.order_status == 'exchange_in_process'
                          ? 'inProcess'
                          : ''
                          || items.order_status == 'exchange_accepted'
                          ? 'delivery'
                          : ''
                          || items.order_status == 'exchange_rejected'
                          ? 'return'
                          : ''
                      "
                    >
                      {{ items.order_status }}
                    </p>
                    <div v-if="items.order_status =='exchange_in_process' || items.order_status =='exchange_accepted' || items.order_status =='item_returned_to_store' && items.type=='exchange' " class="exchage-box">
                      <div class="inner-box">
                        
                        <div class="step-box">
                          <span class="checkmark active"><img  src="/img/Vector.png"></span>
                          <span class="return-box-line active"></span>
                        </div>
                        <div class="detail-box">
                          <p>Replacement Request Submitted</p>
                        </div>
                      </div>

                      <div class="inner-box">
                        <div class="step-box">
                          <span style="margin-left:-2px" v-if="items.order_status == 'exchange_accepted' || items.order_status == 'item_returned_to_store'" class="checkmark active"><img  src="/img/Vector.png"></span>
                          <span style="margin-left:-2px" v-else class="checkmark">1</span>
                        </div>
                        <div class="detail-box">
                          <p v-if="items.return_type=='in_store'">You have opted for an in-store return.Please take the item to the store of purchase with all packaging, tags, freebies and invoice.</p>
                          <p v-else>Our agent will come and pickup the item from the Pickup Address.</p>
                          <div class="info-details">
                             <div v-if="items.return_type=='in_store'" style="margin:10px" class="box1"><span style="font-size: var(--font-size-regular);"><b>Store Name : {{items.store}}</b></span><span></span></div>  
                             <div v-if="items.return_type=='in_store'" style="margin:10px" class="box2"><span style="font-size: var(--font-size-regular);"><b>Store Address : {{items.store_address}}</b></span><span></span></div>
                             <div v-if="items.return_type=='wndw_pickup'" style="margin:15px" class="box3"><span style="font-size: var(--font-size-regular);"><b>Estimated Time of Pickup : <span v-if="items.scheduled_date.length!=0">{{items.scheduled_date}} {{typeof(items.scheduled_date)}}, {{items.scheduled_time_slot}} </span><span v-else>Unscheduled</span></b></span><span></span></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div  class="return-box" v-if="items.order_status == 'return_in_process' || items.order_status == 'return_accepted' || items.order_status == 'returned' || items.order_status == 'item_returned_to_store' && items.type=='return'">
                      <div class="inner-box">
                        <div class="step-box">
                          <span class="checkmark active"><img  src="/img/Vector.png"></span>
                          <span class="return-box-line active"></span>
                        </div>
                        <div class="detail-box">
                          <p>Return Request Submitted</p>
                        </div>
                      </div>

                      <div class="inner-box">
                        <div v-if="items.order_status == 'return_in_process'" class="lining"></div>
                        <div v-if="items.order_status == 'return_accepted' || items.order_status == 'returned' || items.order_status == 'item_returned_to_store'" class="lining-active"></div>
                        <div class="step-box">
                          <span style="margin-left:-2px" v-if="items.order_status == 'return_accepted' || items.order_status == 'returned' || items.order_status == 'item_returned_to_store'" class="checkmark active"><img  src="/img/Vector.png"></span>
                          <span style="margin-left:-2px" v-else class="checkmark">1</span>
                        </div>
                        <div class="detail-box">
                          <p v-if="items.return_type=='in_store'">You have opted for an in-store return.Please take the item to the store of purchase with all packaging, tags, freebies and invoice.</p>
                          <p v-else>Our agent will come and pickup the item from the Pickup Address.</p>
                          <div class="info-details">
                             <div v-if="items.return_type=='in_store'" style="margin:10px" class="box1"><span style="font-size: var(--font-size-regular);"><b>Store Name : {{items.store}}</b></span><span></span></div>  
                             <div v-if="items.return_type=='in_store'" style="margin:10px" class="box2"><span style="font-size: var(--font-size-regular);"><b>Store Address : {{items.store_address}}</b></span><span></span></div>
                             <div v-if="items.return_type=='wndw_pickup'" style="margin:15px" class="box3"><span style="font-size: var(--font-size-regular);"><b>Estimated Time of Pickup : <span v-if="items.scheduled_date.length!=0">{{items.scheduled_date}} , {{items.scheduled_time_slot}} </span><span v-else>Unscheduled</span></b></span><span></span></div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="inner-box">
                        <div class="step-box">
                          <span v-if="items.order_status == 'returned'" class="checkmark active"><img  src="/img/Vector.png"></span>
                          <span v-else class="checkmark">2</span>
                        </div>
                        <div class="detail-box">
                          <p v-if="items.order_status == 'returned'">Refund completed</p>
                          <p v-else>Refund will be initiated once we receive the item and it passes the quality check.</p>
                        </div>
                      </div>
                    </div>

                    <div v-if="items.order_status == 'return_rejected' || items.rejection_type=='return_rejected'" class="return-box">
                      <div class="inner-box">
                        <div class="detail-box">
                          <p style="margin:8px">We regret to inform you that your return request was not accepted by the store. The reason for rejection is given below:</p>
                          <div style="margin:8px" class="info-details">
                             <div class="box1"><span style="font-size: var(--font-size-regular);"><b>Reason : {{items.rejection_reason}}</b></span><span></span></div>  
                          </div>
                          <p style="margin:8px">If you belive this to be incorrect, please visit the store for an in-store return or contact us at <a href="mailto:customercare@wndw.in">customercare@wndw.in</a></p>
                        </div>
                      </div>
                    </div>

                    <div v-if="items.order_status == 'exchange_rejected' || items.rejection_type=='exchange_rejected'" class="return-box">
                      <div class="inner-box">
                        <div class="detail-box">
                          <p style="margin:8px">We regret to inform you that your exchange request was not accepted by the store. The reason for rejection is given below:</p>
                          <div style="margin:8px" class="info-details">
                             <div class="box1"><span style="font-size: var(--font-size-regular);"><b>Reason : {{items.rejection_reason}}</b></span><span></span></div>  
                          </div>
                          <p style="margin:8px">If you belive this to be incorrect, please visit the store for an in-store return or contact us at <a href="mailto:customercare@wndw.in">customercare@wndw.in</a></p>
                        </div>
                      </div>
                    </div>

                    <div v-if="items.rejection_type == 'pickup_return_rejected' || items.rejection_type == 'pickup_exchange_rejected'" class="return-box">
                      <div class="inner-box">
                        <div class="detail-box">
                          <p style="margin:8px">We regret to inform you that the store is unable to process your <span v-if="items.rejection_type == 'pickup_return_rejected'">return</span> <span v-if="items.rejection_type == 'pickup_exchange_rejected'">exchange</span> request with the information shared. The reason for rejection is given below:</p>
                          <div style="margin:8px" class="info-details">
                             <div class="box1"><span style="font-size: var(--font-size-regular);"><b>Reason : {{items.rejection_reason}}</b></span><span></span></div>  
                          </div>
                          <p style="margin:8px">If you belive this to be incorrect, please visit the store for an in-store return or contact us at <a href="mailto:customercare@wndw.in">customercare@wndw.in</a></p>
                        </div>
                      </div>
                    </div>

                    <!-- <div v-if="items.rejection_reason !=''" class="return-box">
                       <div class="inner-box">
                        <div class="detail-box">
                          <p style="margin:8px">We regret to inform you that your request has been rejected by the store. The reason for rejection is given below.</p>
                          <div style="margin:8px" class="info-details">
                             <div class="box1"><span style="font-size: var(--font-size-regular);"><b>Reason : {{items.rejection_reason}}</b></span><span></span></div>  
                          </div>
                          <p style="margin:8px">If you belive this to be incorrect, please visit the store for an in-store return or contact us at <a href="mailto:customercare@wndw.in">customercare@wndw.in</a></p>
                        </div>
                      </div>
                    </div> -->

                  </div>
                </div> 
                <div class="newOrderProductDetail">
                  <router-link
                      v-if="items.store != 'hopped'"
                      class="newOrderProductImg"
                      :to="{
                      name: 'order-detail',
                      path: '/order-detail.html',
                      params: { id: items.order_quote_id, id: items.item_id },
                      query: {
                        id: items.order_quote_id,
                        item_id: items.item_id,
                      },
                    }"
                  >
                    <responsive-image
                        v-bind:desktop="`${$root.image_url_c}inside/100x100/${items.image}`"
                        v-bind:tab="`${$root.image_url_c}inside/100x100/${items.image}`"
                        v-bind:mobile="`${$root.image_url_c}inside/100x100/${items.image}`"
                        v-bind:default_image="`${$root.image_url_c}inside/100x100/${items.image}`"
                    />
                  </router-link>
                  <div v-else class="newOrderProductImg">
                    <responsive-image
                        v-bind:desktop="`${$root.image_url_c}inside/100x100/${items.image}`"
                        v-bind:tab="`${$root.image_url_c}inside/100x100/${items.image}`"
                        v-bind:mobile="`${$root.image_url_c}inside/100x100/${items.image}`"
                        v-bind:default_image="`${$root.image_url_c}inside/100x100/${items.image}`"
                    />
                  </div>
                  <div class="newOrderProductDetailRight">
                    <router-link
                        :to="{
                        name: 'order-detail',
                        path: '/order-detail.html',
                        params: { id: items.order_quote_id, id: items.item_id },
                        query: {
                          id: items.order_quote_id,
                          item_id: items.item_id,
                        },
                      }"
                    >{{ items.name }}</router-link
                    >
                    <p>
                      <b>{{ parseFloat(items.row_total) | formatMoney }}</b>
                    </p>
                    <p v-if="items.size">Size : {{ items.size }}</p>
                    <p class="card_sold mb-0" v-if="items.store == 'hopped'">
                      Not yet accepted
                    </p>
                    <p class="card_sold mb-0" v-else>
                      Sold By: {{ items.store }}
                    </p>
                    <div class="px-2 ml-1">
                      <div
                          v-if="
                          items.rating != null && items.rating.rr_rating != null
                        "
                      >
                        <span
                            v-for="(star, i) in Number(items.rating.rr_rating)"
                            :key="i"
                            style="display: inline"
                        >
                          <span>
                            <i class="fa fa-star pl-1"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row w-100 newOrderBtnWrap">
                  <div
                      class="col-md-3 col-6"
                      v-if="
                      items.schedule_rto ||
                      items.schedule_failed_exchange ||
                      items.schedule_return
                    "
                  >
                    <p
                        class="reviewPopup float-right btn-outline"
                        @click.prevent="re_order(items)"
                    >
                      Schedule Delivery
                    </p>
                  </div>
                  <div class="col-md-3 col-6" v-if="items.schedule_exchange">
                    <p
                        class="reviewPopup float-right btn-outline"
                        @click="getTimeSlotsForSchedule(items.item_id)"
                    >
                      Schedule Delivery
                    </p>
                  </div>
                  <div
                      class="row w-100 newOrderBtnWrap"
                      v-if="
                    items.order_status == 'delivered' ||
                      items.order_status == 'returned' ||
                      items.order_status == 'refund_processed'
                    "
                  >
                    <div class="col-md-3 col-6">
                      <p
                          class="reviewPopup float-right btn-outline"
                          @click="
                          ratingModelOpen(
                            items.sku,
                            items.variant_id,
                            items.store_id,
                            items.order_quote_id
                          )
                        "
                      >
                        Review Product
                      </p>
                    </div>
                    <div
                        class="col-md-3 col-6"
                       
                    >
                      <p
                          class="reviewPopup float-right btn-outline"
                          @click="
                          storeRatingModelOpen(
                            items.master_sku,
                            items.variant_id,
                            items.store_id,
                            items.order_quote_id
                          )
                        "
                      >
                        Review Store
                      </p>
                    </div>
                    <div class="col-md-3 col-6" v-if="items.schedule_exchange">
                      <p
                          class="reviewPopup float-right btn-outline"
                          @click="getTimeSlotsForSchedule(items.item_id)"
                      >
                        Schedule Delivery
                      </p>
                    </div>
					<div class="col-md-3 col-6" v-if="items.order_status == 'delivered'">
						 <button 
                          class="btn w-100 rounded-0 returnExchange"
                          @click.prevent="order_return_open(items)" >
                        Return / Replace
                      </button>
					</div>
					
                  </div>
                  <div
                      class="col-md-3 col-6"
                      v-if="
                        items.is_picked_up == 1 &&
                        items.order_status == 'shipped'
                      "
                  >
                    <button
                        class="btn text-white bg-logo-color w-100 rounded-0"
                        @click="
                          getRouteData(
                            items.order_quote_id,
                            items.is_picked_up,
                            items.rider_name,
                            items.rider_number
                          )
                        "
                    >
                      Track
                    </button>
                  </div>
				  <div class="col-md-3 col-6 mt-3">
                    
                      <!-- {{items.store_id}} -->
                      <span v-if="items.showTimer">
                        <button
                            v-if="
                            items.order_status == 'pending' &&
                            items.replicated_from == 0
                          "
                            class="btn w-100 rounded-0 returnExchange"
                            @click="
                            orderCancelModal(
                              items.order_quote_id,
                              items.item_id,
                              items.store_id,
                              i,
                              true,
                              items.refundable_method
                            )
                          "
                        >
                          Free Cancellation
                          <br />
                          {{ timeRemaining[i].time | convertTime }}
                        </button>
                      </span>
                      <span v-else>
                        <button
                            v-if="
                            items.order_status == 'pending' &&
                            items.replicated_from == 0 &&
                            items.can_cancel
                          "
                            class="btn w-100 rounded-0 returnExchange"
                            @click="
                            orderCancelModal(
                              items.order_quote_id,
                              items.item_id,
                              items.store_id,
                              i,
                              false,
                              items.refundable_method
                            )
                          "
                        >
                          Cancel
                        </button>
                      </span>

                     
                    </div>
                </div>
					
                <!-- <div class="content-box">

                             <table class="table order-table">
                              <thead>
                                <tr>
                                  <th>Order #</th>
                                  <th>Date</th>
                                  <th>Ship To</th>
                                  <th>Order Total</th>
                                  <th>Status</th>
                                  <th class="text-right">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="items in order">
                                  <td v-text="items.order_increment_id" class="order"></td>
                                  <td v-text="items.order_date" class="order-date"></td>
                                  <td v-text="items.shipping_name" class="name"></td>
                                  <td v-text="'Rs. '+items.grand_total" class="total"></td>
                                  <td v-text="items.status" class="status"></td>
                                  <td class="action text-right"><button class="order-with-cod" v-if="items.showCOD == 1" @click="order_with_cod(items.order_quote_id)">Reorder with <span>CASH ON DELIVERY</span></button> <a href="#" v-if="items.showCOD != 1" @click.prevent="reorder(items.order_quote_id)" class="reorder">Reorder</a> <router-link :to="{name:'order-detail' , path: '/order-detail.html' , params: {id: items.order_quote_id} , query: {id: items.order_quote_id}}">View Order</router-link></td>
                                </tr>
                              </tbody>
                            </table>
                            <p v-if="!order.length">No Order found</p>

							</div>-->
              </div>
              <div
                  class="viewMoreWraper"
                  v-if="order.length && isMoreOrders == true"
              >
                <div v-if="isViewMore">
                  <loading-icon
                      class="loading-icon newLoader"
                      name="ball-clip-rotate-multiple"
                      color="#ba2126"
                      scale="1"
                  ></loading-icon>
                </div>
                <div v-if="order.length > 5" class="viewMoreBtnOrder" @click="get_orders()">
                  View More
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- My code -->
      <div
          v-if="returnProcess"
          class="modal size-guide-popup-container"
          :class="returnProcess ? 'active' : ''"
          id="coupon-modal"
      >
        <div class="modal-dialog model-lg" style="max-width: 800px">
          <div class="modal-content" style="height: 400px; overflow: auto">
            <div class="modal-body">
              <div class="moreStores">
                <h3>
                  {{ this.exchange_type }} Request
                  <button
                      type="button"
                      class="close popupClose"
                      @click="handleClose()"
                  >
                    &times;
                  </button>
                </h3>
                <div>
                  <table class="table order-table">
                    <thead>
                    <tr>
                      <th class="font-bold">Name</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>
                        <span class="ProdName">{{ returnItem.name }}</span>
                      </td>
                    </tr>
                    <!---->
                    <tr>
                      <!-- this td for return tab -->
                      <td colspan="5" class="select-order">
                        <form class="reasons_form reasons_form_return">
                          <div
                              class="
                                reason-container
                                mb-3
                                w-100
                                text-md-left text-center
                              "
                          >
                            <span>Select Return Type</span>
                            <br />
                            <span class="mr-4">
                                <input
                                    id="credits"
                                    class="mr-2"
                                    type="radio"
                                    value="in_store"
                                    v-model="returnType"
                                />
                                <label for="credits">In Store</label>
                              </span>
                            <span class="mr-4">
                                <input
                                    id="source"
                                    class="mr-2"
                                    type="radio"
                                    value="wndw_pickup"
                                    v-model="returnType"
                                />
                                <label for="source">WNDW Pickup</label>
                              </span>
							  <div
								v-if="returnType == `wndw_pickup`"
								class="reason-container w-100"
								>
								<span class="mr-3">Delivery Charges -</span>
								<span class="font-weight-bold"
								>Rs. {{ this.rtoShippingCharger }}</span
								>
							</div>
                          </div>
                        </form>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  

                  <div class="customTab mt-4 returnTab">
                    <span class="pl-2 pb-4">Schedule</span>
                    <ul>
                      <li
                          @click="getTimeSlot(index)"
                          v-for="(item, index) in slots"
                          :key="index"
                          class="tabTitle"
                          :class="{ titleAcitve: selectedDate == index }"
                      >
                        {{ new Date(index).toString().split(" ")[0] }}
                        <span>
                          {{ new Date(index).toString().split(" ")[2] }}
                          {{ new Date(index).toString().split(" ")[1] }}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <!-- <div class="tabDetail tabActive"> -->
                  <!-- slotActive -->
                  <!-- {{timeSlot}} -->
                  <div class="tabDate">
                    <div
                        class="timeSlot"
                        v-for="(time, i) in timeSlot"
                        :key="i"
                        :class="{
                        slotDisable: !time.is_available,
                        slotActive:
                          selectedTimeSlot.time_slot == time.time_slot,
                      }"
                        @click="
                        selectTimeSlot(
                          time.time_slot,
                          time.is_available,
                          time.slot_id,
                          time.time_slot_id
                        )
                      "
                    >
                      {{ time.time_slot }}
                    </div>
                  </div>
                  <div v-if="loader == true && returnType == `wndw_pickup`" >
                    <button style="cursor: not-allowed" class="input-text form-control submit" disabled>
                      Pay
                    </button>
                  </div>
                  <div v-if="loader == true && returnType != `wndw_pickup`" >
                    <button style="cursor: not-allowed" class="input-text form-control submit" disabled>
                      Submit
                    </button>
                  </div>

                  <button
                      v-if="returnType == `wndw_pickup` && loader == false"
                      :class="this.selectedTimeSlot.booked ? false : 'cursorNotAlllowed'"
                      :disabled="this.selectTimeSlot.booked ? false : false"
                      class="input-text form-control submit"
                      @click="initPayment"
                  >
                    Pay
                  </button>
                  <button v-if="returnType != `wndw_pickup` && loader == false"  class="input-text form-control submit" @click="scheduleInStore"
                          :class="this.selectedTimeSlot.booked ? false : 'cursorNotAlllowed'"
                          :disabled="this.selectTimeSlot.booked ? false : false"
                  >
                    Submit
                  </button>
                  <!-- </div> -->

                  <!-- <div class="tabDetail tabActive">
                  <div class="timeSlot slotDisable">10:00 AM - 12:00 PM</div>
                  <div class="timeSlot slotDisable">12:00 PM - 2:00 PM</div>
                  <div class="timeSlot">2:00 PM - 4:00 PM</div>
                </div>-->
                </div>
              </div>

              <!-- <Login /> -->
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="returnRequest == true"
          class="modal size-guide-popup-container"
          :class="returnRequest ? 'active' : ''"
          id="coupon-modal"
      >
        <div class="overFlow" @click="handleClose()"></div>
        <div class="modal-dialog model-lg" style="max-width: 800px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="moreStores">
                <h3>
                  Request Return/Replace
                  <button
                      type="button"
                      class="close popupClose"
                      @click="handleClose()"
                  >
                    &times;
                  </button>
                  
                </h3>
                <div v-if="!isSlotsActive">
                  <table class="table order-table">
                    <thead>
                    <tr>
                      <th class="font-bold">Name</th>
                      <th class="font-bold">Qty</th>
                      <th class="font-bold">Total</th>
                      <th class="font-bold">Date</th>
                      <th class="text-right font-bold">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>
                        <!-- <img alt="" width="60px"> -->
                        <span class="ProdName">{{ returnItem.name }}</span>
                      </td>
                      <td class="qty cart-item text-center">
                        {{ returnItem.qty }}
                      </td>
                      <td class="total">
                        {{ returnItem.price | formatMoney }}
                      </td>
                      <td class="order-date">{{ returnItem.created_at }}</td>
                      <td class="action text-right">
                        <a
                            href="#!"
                            class="actionBtn"
                            :class="tab == 1 ? 'requestActive' : ''"
                            @click="returnreplace(1)"
                        >Return</a
                        >
                        <a
                            href="#!"
                            class="actionBtn"
                            :class="tab == 2 ? 'requestActive' : ''"
                            @click="returnreplace(2)"
                        >Replace</a
                        >
                      </td>
                    </tr>
                    <!---->
                    <tr>
                      <!-- this td for return tab -->
                      <td colspan="5" class="select-order" v-if="tab == 1">
                        <form class="reasons_form reasons_form_return">
                          <div class="reason-container mb-3 w-100 cart-item">
                            <!-- <label class="d-block">Select Quantity</label> -->
                            <!-- <div class="qty_box float-left" style="width: 150px;"><a href="#" class="disabled"><i class="fa fa-minus"></i></a><input type="text" max="1" min="1" readonly="readonly"><a href="#" class="disabled"><i class="fa fa-plus"></i></a><span> /</span><span>1</span></div> -->
                            <div class="total_price">
                              Total: {{ returnItem.price | formatMoney }}
                            </div>
                          </div>

                          <div class="reason-container mb-3 w-100">
                            <span>Select Return Type</span>
                            <br />
                            <span class="mr-4">
                                <input
                                    id="credits"
                                    class="mr-2"
                                    type="radio"
                                    value="in_store"
                                    v-model="returnType"
                                />
                                <label for="credits">In Store</label>
                              </span>
                            <span class="mr-4">
                                <input
                                    id="source"
                                    class="mr-2"
                                    type="radio"
                                    value="wndw_pickup"
                                    v-model="returnType"
                                />
                                <label for="source">WNDW Pickup</label>
                              </span>
                          </div>

                          <div class="reason-container mb-3 w-100">
                            <span>Select Return Payment Method</span>

                            <span
                                class="text-danger"
                                v-show="returnMessage"
                            >{{ returnMessage }}</span
                            >
                            <br />
                            <span class="mr-4">
                                <input
                                    class="mr-2"
                                    type="radio"
                                    id="wndwCredits"
                                    value="credits"
                                    v-model="selectedReturnPayment"
                                />
                                <label for="wndwCredits">WNDW Credits</label>
                              </span>
                            <span class="mr-4" v-if="isSource">
                                <input
                                    class="mr-2"
                                    type="radio"
                                    id="paymentMode"
                                    value="source"
                                    v-model="selectedReturnPayment"
                                />
                                <label for="paymentMode"
                                >Source Payment Method</label
                                >
                                <br />
                              </span>
                            <p v-if="selectedReturnPayment == 'source'">
                              May take upto 5-7 business days
                            </p>
                          </div>
                                <div class="product-images">
                                  <h5>Upload Product Images (PNG, JPG or PDF)</h5>
                                    <input
                                    @change="uploadimage($event,returnItem.order_quote_id,returnItem.item_id)"
                                    type="file"
                                    accept="image/*"
                                    id="returnexchangeimage"
                                    style="display:block"
                              
                                  />
                                  <div v-if="uploadProcess" class="mt-4 image-progress-bar">
                                    <progress max="100"></progress>
                                    <h5>Uploading In Progress...</h5>
                                  </div>
                                  <div class="product-thumbnail mt-4">
                                     
                                    <div class="thumbnail" v-for="(image,index) in images" :key="index" >
                                     <img class="thumb-img" :src="image.image_url">
                                     <button @click.prevent="removeimage(image.id,index)" class="thumbnail-remove-button">Remove</button>
                                    </div>
                                  </div>
                                </div>
                          <div class="reason-container mb-3 w-100">
                            <span>Select Return Reasons</span>

                            <select
                                @change="onChangeReason($event)"
                                required="required"
                                class="input-text form-control"
                                v-model="selectedReason"
                                placeholder="--Select Return Reasons--"
                            >
                              <option value disabled>Select a reason</option>
                              <option
                                  v-for="(reason, index) in reasons"
                                  :key="index"
                                  :value="reason.id"
                                  v-if="reason.type == 'return'"
                              >
                                {{ reason.reason }}
                              </option>
                              <!-- <option value="">--Select Return Reasons--</option>
                          <option value="Size Fit Issue">Size Fit Issue</option>
                          <option value="Received a different size">Received a different size</option>
                          <option value="Received a different Color">Received a different Color</option>
                          <option value="Quality Issue">Quality Issue</option>
                          <option value="Item no loger wanted">Item no loger wanted</option>
                          <option value="Item or part was broken/Damaged on Arrival">Item or part was broken/Damaged on Arrival</option>
                            <option value="Expected a different style/Fit">Expected a different style/Fit</option>-->
                            </select>
                            <div
                                v-if="returnReasonShipping"
                                class="text-logo-color"
                            >
                              {{ returnShippingCharge | formatMoney }}
                              {{ returnReasonShipping }}
                            </div>
                          </div>
                          <div class="reason-container comments mb-3">
                              <textarea
                                  placeholder="Comments (optional)"
                                  maxlength="490"
                                  class="w-100 form-control"
                                  v-model="comment"
                              ></textarea>
                          </div>
                          <div v-if="returnType=='in_store'" class="store-details">
                            <p>You have opted for an in-store return. Please take the item to the store of purchase with all packaging, tags, freebies and invoice.</p>
                            <p>The store details are:</p>
                            <h5>{{storeName}}</h5>
                             <h5>{{storeAddress}}</h5>
                            </div>
                          <button
                              v-if="!isSlotsActive && returnType=='wndw_pickup'"
                              class="input-text form-control submit"
                              @click.prevent="
                                returnExchangeSlotsHandler(
                                  returnItem.order_quote_id,
                                  returnItem.item_id
                                )
                              "
                          >
                            Schedule
                          </button>
                           <button
                              v-else
                              class="input-text form-control submit"
                              @click.prevent="
                        order_return_new(
                          returnItem.order_quote_id,
                          returnItem.item_id
                        )
                      "
                          >
                            Submit
                          </button>


                          <!-- <button
                          class="input-text form-control submit pr-2 mr-2"
                          @click="returnRequest = false"
                        >
                          Cancel
                        </button>-->
                        </form>

                      </td>

                      <!-- this td for exchange tab -->
                      <td colspan="6" class="select-order" v-if="tab == 2">
                        <form class="reasons_form">
                          <div class="reason-container mb-3 w-100 cart-item">
                            <!-- <label class="d-block">Select Quantity</label>
                          <div class="qty_box float-left" style="width: 150px;"><a href="#" class="disabled"><i class="fa fa-minus"></i></a><input type="text" max="1" min="1" readonly="readonly"><a href="#" class="disabled"><i class="fa fa-plus"></i></a><span> /</span><span>1</span></div>-->
                            <div class="total_price">
                              Total: {{ returnItem.price }}
                            </div>
                          </div>
                          <div class="product-detail-container p-0"></div>
                          <div class="reason-container mb-3 w-100">
                            <span>Select Replacement Type</span>
                            <br />
                            <span class="mr-4">
                                <input
                                    id="credits"
                                    class="mr-2"
                                    type="radio"
                                    value="in_store"
                                    v-model="returnType"
                                />
                                <label for="credits">In Store</label>
                              </span>
                            <span class="mr-4">
                                <input
                                    id="source"
                                    class="mr-2"
                                    type="radio"
                                    value="wndw_pickup"
                                    v-model="returnType"
                                />
                                <label for="source">WNDW Pickup</label>
                              </span>
                          </div>

                                <div class="product-images">
                                  <h5>Upload Product Images (PNG, JPG or PDF)</h5>
                                    <input
                                    @change="uploadimage($event,returnItem.order_quote_id,returnItem.item_id)"
                                    type="file"
                                    accept="image/*"
                                    id="returnexchangeimage"
                                    style="display:block"
                              
                                  />
                                  <div class="image-progress-bar">
                                    <progress style="display:block" max="100"></progress>
                                  </div>
                                  <div class="product-thumbnail mt-4">
                                    <div class="thumbnail" v-for="(image,index) in images" :key="index" >
                                     <img class="thumb-img" :src="image.image_url">
                                     <button @click.prevent="removeimage(image.id,index)" class="thumbnail-remove-button">Remove</button>
                                    </div>
                                  </div>
                                </div>

                          <div class="reason-container mb-3 w-100">
                            <span>Select Return Reasons</span>
                            <select
                                required="required"
                                class="input-text form-control"
                                v-model="selectedReason"
                                placeholder="--Select Return Reasons--"
                            >
                              <option value disabled>Select a reason</option>
                              <option
                                  v-for="(reason, index) in reasons"
                                  :key="index"
                                  :value="reason.id"
                                  v-if="reason.type == 'exchange'"
                              >
                                {{ reason.reason }}
                              </option>
                              <!-- <option value="">--Select Return Reasons--</option>
                          <option value="Size Fit Issue">Size Fit Issue</option>
                          <option value="Received a different size">Received a different size</option>
                          <option value="Received a different Color">Received a different Color</option>
                          <option value="Quality Issue">Quality Issue</option>
                          <option value="Item no loger wanted">Item no loger wanted</option>
                          <option value="Item or part was broken/Damaged on Arrival">Item or part was broken/Damaged on Arrival</option>
                            <option value="Expected a different style/Fit">Expected a different style/Fit</option>-->
                            </select>
                          </div>
                          <!-- <div class="reason-container mb-3">
                          <textarea
                            placeholder="Please Enter Exchange Reason*"
                            maxlength="490"
                            class="w-100 form-control rounded-0"
                          ></textarea>
                          <p style="color: red; font-size: var(--font-size-regular);"></p>
                        </div>-->
                          <div class="reason-container comments mb-3">
                              <textarea
                                  placeholder="Comments (optional)"
                                  maxlength="490"
                                  class="w-100 form-control rounded-0"
                                  v-model="comment"
                              ></textarea>
                          </div>
                          <div v-if="returnType=='in_store'" class="store-details">
                            <p>You have opted for an in-store return. Please take the item to the store of purchase with all packaging, tags, freebies and invoice.</p>
                            <p>The store details are:</p>
                            <h5>{{storeName}}</h5>
                             <h5>{{storeAddress}}</h5>
                            </div>
                          <button
                              v-if="!isSlotsActive && returnType=='wndw_pickup'"
                              class="input-text form-control submit"
                              @click.prevent="
                                returnExchangeSlotsHandler(
                                  returnItem.order_quote_id,
                                  returnItem.item_id
                                )
                              "
                          >
                            Schedule
                          </button>
                          <button
                              v-else
                              class="input-text form-control submit"
                              @click.prevent="
                        exchange_new(returnItem.order_quote_id, returnItem.item_id)
                      "
                          >
                            Submit
                          </button>
                          <!-- <button
                          v-else
                          class="input-text form-control submit"
                          @click.prevent="
                            exchange(
                              returnItem.order_quote_id,
                              returnItem.item_id
                            )"
                        >Submit</button>-->
                        </form>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else>
                  <div class="customTab mt-5 returnTab">
                    <ul>
                      <li
                          @click="getTimeSlot(index)"
                          v-for="(item, index) in slots"
                          :key="index"
                          class="tabTitle"
                          :class="{ titleAcitve: selectedDate == index }"
                      >
                        {{ new Date(index).toString().split(" ")[0] }}
                        <span>
                          {{ new Date(index).toString().split(" ")[2] }}
                          {{ new Date(index).toString().split(" ")[1] }}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <!-- <div class="tabDetail tabActive"> -->
                  <!-- slotActive -->
                  <!-- {{timeSlot}} -->
                  <div class="tabDate returnTabData">
                    <div
                        class="timeSlot"
                        v-for="(time, i) in timeSlot"
                        :key="i"
                        :class="{
                        slotDisable: !time.is_available,
                        slotActive: selectedTimeSlot.slot_id == time.slot_id,
                      }"
                        @click="
                        selectTimeSlot(
                          time.time_slot,
                          time.is_available,
                          time.slot_id,
                          time.time_slot_id
                        )
                      "
                    >
                      {{ time.time_slot }}
                    </div>

                    <button
                        v-if="tab == 1"
                        class="input-text form-control submit"
                        @click.prevent="
                        order_return(
                          returnItem.order_quote_id,
                          returnItem.item_id
                        )
                      "
                    >
                      Submit
                    </button>
                    <button
                        v-if="tab == 2"
                        class="input-text form-control submit"
                        @click.prevent="
                        exchange(returnItem.order_quote_id, returnItem.item_id)
                      "
                    >
                      Submit
                    </button>
                  </div>

                  <!-- <div class="tabDetail tabActive">
									<div class="timeSlot slotDisable">10:00 AM - 12:00 PM</div>
									<div class="timeSlot slotDisable">12:00 PM - 2:00 PM</div>
									<div class="timeSlot">2:00 PM - 4:00 PM</div>
								</div>-->
                </div>
                <p style="color:red">Please note that all refund and replacement requests are subject to a quality check at the store of purchase.</p>
              </div>

              <!-- <Login /> -->
            </div>
          </div>
        </div>
      </div>
      <div class="modal active" id="coupon-modal" v-if="ratingModel == true">
        <div class="overFlow" @click="ratingModel = false"></div>
        <div class="modal-dialog modal-sm" style="max-width: 400px">
          <div class="modal-content">
            <div class="modal-body">
              <!-- class="close" -->
              <button
                  type="button"
                  class="close"
                  @click="ratingModel = false"
                  style="
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  margin-top: -10px !important;
                  z-index: 999;
                "
              >
                &times;
              </button>
              <div class="orderReview">
                <h3>PRODUCT REVIEW</h3>
                <form @submit="customer_review">
                  <!-- <label class="w-100">Title *</label> -->
                  <!-- <input
									placeholder="Title"
									type="text"
									class="w-100 form-control"
									v-model="rating.title"
									required
								/>-->
                  <div class="stars mt-3 mb-2">
                    <input
                        class="star star-5"
                        v-model="rating.star"
                        id="star-5"
                        type="radio"
                        value="5"
                        name="star"
                        required
                    />
                    <label class="star star-5" for="star-5"></label>
                    <input
                        v-model="rating.star"
                        class="star star-4"
                        id="star-4"
                        type="radio"
                        value="4"
                        name="star"
                        required
                    />
                    <label class="star star-4" for="star-4"></label>
                    <input
                        v-model="rating.star"
                        class="star star-3"
                        id="star-3"
                        type="radio"
                        value="3"
                        name="star"
                        required
                    />
                    <label class="star star-3" for="star-3"></label>
                    <input
                        v-model="rating.star"
                        class="star star-2"
                        id="star-2"
                        type="radio"
                        value="2"
                        name="star"
                        required
                    />
                    <label class="star star-2" for="star-2"></label>
                    <input
                        v-model="rating.star"
                        class="star star-1"
                        id="star-1"
                        type="radio"
                        value="1"
                        name="star"
                        required
                    />
                    <label class="star star-1" for="star-1"></label>
                  </div>
                  <!-- <label class="w-100">Comments *</label> -->
                  <textarea
                      placeholder="Comments"
                      class="w-100 form-control"
                      v-model="rating.review"
                  ></textarea>
                  <button type="submit" class="review-submit">Submit</button>
                </form>
              </div>

              <!-- <Login /> -->
            </div>
          </div>
        </div>
      </div>
      <div
          class="modal active"
          id="coupon-modal"
          v-if="storeRatingModel == true"
      >
        <div class="overFlow" @click="storeRatingModel = false"></div>
        <div class="modal-dialog modal-sm" style="max-width: 400px">
          <div class="modal-content">
            <div class="modal-body">
              <!-- class="close" -->
              <button
                  type="button"
                  class="close"
                  @click="storeRatingModel = false"
                  style="
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  margin-top: -10px !important;
                  z-index: 999;
                "
              >
                &times;
              </button>
              <div class="orderReview storeReview">
                <h3>STORE REVIEW</h3>
                <form @submit="store_review">
                  <!-- <label class="w-100">Title *</label> -->
                  <!-- <input
									placeholder="Title"
									type="text"
									class="w-100 form-control"
									v-model="rating.title"
									required
								/>-->
                  <div class="stars mt-3 mb-2">
                    <input
                        class="star star-5"
                        v-model="rating.star"
                        id="star-5"
                        type="radio"
                        value="5"
                        name="star"
                        required
                    />
                    <label class="star star-5" for="star-5"></label>
                    <input
                        v-model="rating.star"
                        class="star star-4"
                        id="star-4"
                        type="radio"
                        value="4"
                        name="star"
                        required
                    />
                    <label class="star star-4" for="star-4"></label>
                    <input
                        v-model="rating.star"
                        class="star star-3"
                        id="star-3"
                        type="radio"
                        value="3"
                        name="star"
                        required
                    />
                    <label class="star star-3" for="star-3"></label>
                    <input
                        v-model="rating.star"
                        class="star star-2"
                        id="star-2"
                        type="radio"
                        value="2"
                        name="star"
                        required
                    />
                    <label class="star star-2" for="star-2"></label>
                    <input
                        v-model="rating.star"
                        class="star star-1"
                        id="star-1"
                        type="radio"
                        value="1"
                        name="star"
                        required
                    />
                    <label class="star star-1" for="star-1"></label>
                  </div>
                  <!-- <label class="w-100">Comments *</label> -->
                  <textarea
                      placeholder="Comments"
                      class="w-100 form-control"
                      v-model="rating.review"
                  ></textarea>
                  <button type="submit" class="review-submit">Submit</button>
                </form>
              </div>

              <!-- <Login /> -->
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="cancelPopup == true"
          class="modal active cancelConfirmation"
          id="coupon-modal"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body text-center">
              <span
                  style="
                  font-size: 70px;
                  border: 3px solid orange;
                  color: orange;
                  width: 90px;
                  height: 90px;
                  line-height: 90px;
                  border-radius: 50px;
                  display: inline-block;
                  margin: 17px 0;
                "
              >!</span
              >

              <p v-if="freeCancelMessage == ''">
                Are you sure you want to cancel this order?
              </p>

              <p v-else v-show="freeCancelMessage">{{ freeCancelMessage }}</p>
              <span
                  class="mr-3 cancelRadio"
                  v-for="(item, index) in cancelPayments"
                  :key="index"
              >
                <input
                    class="mr-2"
                    :id="{ item }"
                    type="radio"
                    name="payments"
                    v-model="payment"
                    :value="{ item }"
                />
                <label :for="{ item }">{{ item }}</label>
              </span>
            </div>
            <div class="modal-footer">
              <button
                  v-if="!$root.page_loader"
                  @click="orderCancelModal"
                  type="button"
                  class="
                  btn
                  rounded-0
                  bg-white
                  text-dark
                  border-1 border-secondary
                "
                  data-dismiss="modal"
              >
                No
              </button>

              <button
                  v-if="!$root.page_loader"
                  @click="cancel_order()"
                  type="button"
                  class="btn bg-logo-color rounded-0 text-white"
              >
                <span>Yes Cancel it</span>
              </button>

              <button
                  v-else
                  type="button"
                  class="btn bg-logo-color rounded-0 text-white"
              >
                <span>
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
          :key="keyMap"
          class="modal orderTracking"
          v-bind:class="{ active: this.isMap === false }"
          id="coupon-modal"
      >
        <!-- @click="close_store_popup()" -->
        <div class="modal-dialog">
          <div
              class="modal-content"
              style="border-radius: 6px !important; overflow: hidden"
          >
            <div class="modal-body p-0">
              <!-- class="close" -->
              <!-- @click="close_store_popup()" -->

              <div class="trackingBox row">
                <div class="col-md-7">
                  <!-- <b>Start:</b>
							<select v-model="start">
								<option value="28.5814167,77.3141703">Chicago</option>

							</select>
							<b>End:</b>
							<select v-model="end">
								<option value="28.5794860,77.3284170">Chicago</option>

								</select>-->

                  <GmapMap
                      :zoom="7"
                      :center="{ lat: 20.5937, lng: 78.9629 }"
                      style="width: 100%; height: 500px"
                      @click="mark"
                  >
                    <DirectionsRenderer
                        travelMode="DRIVING"
                        :origin="origin"
                        :destination="destionation"
                    />
                    <GmapMarker
              v-for="(marker, i) in markers"
              :position="marker.position"
              :clickable="true"
              :draggable="true"
              :key="i"
              />
                  </GmapMap>

                  <!-- <h4 class="mapPopHeading p-3">
								Set your delivery location
								<button
									type="button"
									class="close"
									style=""
									@click="isMap = true"
								>
									&times;
								</button>
								</h4>-->
                </div>
                <div class="col-md-5">
                  <h4 class="trackHeading">Order Status</h4>
                  <div
                      class="statusStepper"
                      :class="{ trakerCollapse: mobileTrackIcon }"
                  >
                    <i
                        @click="trackCollaps"
                        class="fa fa-angle-down collapseIcon"
                    ></i>
                    <div class="steps completedStep">
                      <div class="statusMark">
                        <img src="/img/trackingCheck.png" alt />
                        <span>1</span>
                      </div>
                      <div class="mainStatus">
                        <p>Order Placed</p>
                        <span
                        >We have received your order ({{
                            order_detail.scheduled_date
                          }})</span
                        >
                      </div>
                    </div>
                    <div
                        class="steps"
                        :class="[
                        order_detail.shipment_status == 'order_picked_up' ||
                        order_detail.shipment_status == 'order_delivered'
                          ? 'completedStep'
                          : 'pendingStep',
                      ]"
                    >
                      <div class="statusMark">
                        <img src="/img/trackingCheck.png" alt />
                        <span>2</span>
                      </div>
                      <div class="mainStatus">
                        <p>Shipped</p>
                        <!-- <span>Arriving in 2 Hour, 3 Min</span> -->
                      </div>
                    </div>
                    <div
                        class="steps"
                        :class="[
                        order_detail.shipment_status == 'order_delivered'
                          ? 'completedStep'
                          : 'pendingStep',
                      ]"
                    >
                      <div class="statusMark">
                        <img src="/img/trackingCheck.png" alt />
                        <span>3</span>
                      </div>
                      <div class="mainStatus">
                        <p>Delivered</p>
                        <!-- <span>Delivery Complete</span> -->
                      </div>
                    </div>
                  </div>
                  <div class="riderDetails">
                    <div class="deliverAddress">
                      <img src="/img/trackLocaterIcons.png" alt />
                      <span
                      >{{ customer_detail.street_address }},{{
                          customer_detail.city
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="riderDetails">
                    <div class="riderName">
                      <img src="/img/riderIcons.png" alt />
                      <span>{{ rider_detail.rider_name }}</span>
                    </div>
                    <div class="riderPhone">
                      <span>+91 {{ rider_detail.rider_number }}</span>
                      <span class="callBtn">
                        <a style="color: white" :href="'tel:' + '9891979302'"
                        >Call</a
                        >
                      </span>
                    </div>
                  </div>
                </div>
                <p class="locationAddress"></p>
                <p class="float-left mx-4 mb-3 mt-4" v-if="riderName">
                  <span>Rider Name: {{ riderName }}</span>
                  <br />
                  <span>Rider Name: {{ riderNumber }}</span>
                </p>

                <span class="trackPopClose" @click="isMap = true">X</span>
              </div>

              <!-- <Login /> -->
            </div>
          </div>
        </div>
      </div>
      <div
          class="modal size-guide-popup-container"
          v-bind:class="{ active: isSchedule }"
          id="coupon-modal"
      >
        <!-- @click="close_store_popup()" -->
        <div class="overFlow" @click="isSchedule = false"></div>
        <div class="modal-dialog model-lg" style="max-width: 500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="moreStores">
                <h3>
                  Schedule
                  <button
                      type="button"
                      class="close popupClose"
                      @click="isSchedule = false"
                  >
                    &times;
                  </button>
                </h3>

                <div class="customTab mt-5 returnTab">
                  <ul>
                    <li
                        @click="getTimeSlot(index)"
                        v-for="(item, index) in slots"
                        :key="index"
                        class="tabTitle"
                        :class="{ titleAcitve: selectedDate == index }"
                    >
                      {{ new Date(index).toString().split(" ")[0] }}
                      <span>
                        {{ new Date(index).toString().split(" ")[2] }}
                        {{ new Date(index).toString().split(" ")[1] }}
                      </span>
                    </li>
                  </ul>
                </div>
                <!-- <div class="tabDetail tabActive"> -->
                <!-- slotActive -->
                <!-- {{timeSlot}} -->
                <div class="tabDate returnTabData">
                  <div
                      class="timeSlot"
                      v-for="(time, i) in timeSlot"
                      :key="i"
                      :class="{
                      slotDisable: !time.is_available,
                      slotActive: selectedTimeSlot.slot_id == time.slot_id,
                    }"
                      @click="
                      selectTimeSlot(
                        time.time_slot,
                        time.is_available,
                        time.slot_id,
                        time.time_slot_id
                      )
                    "
                  >
                    {{ time.time_slot }}
                  </div>

                  <button
                      v-if="tab == 1"
                      class="input-text form-control submit"
                      @click.prevent="handleExchangeSchedule()"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DirectionsRenderer from "@/components/DirectionsRenderer";
export default {
  name: "order",
  components: {DirectionsRenderer },
  metaInfo: {
    title: "Orders",
    meta: [
      {
        name: "description",
        content:
            "Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women’s, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.",
      },
      {
        property: "keywords",
        content:
            "Online Shopping for Women,  W for Woman, women’s dresses online, buy women’s dresses online",
      },
    ],
  },
  data() {
    return {
      uploadProcess:false,
      imageRequiredreasons:[],
      images:[],
      storeName:'',
      storeAddress:'',
      orderLoader:true,
      test: 0,
      loader: false,
      customer_name: "",
      customer_email: "",
      customer_number: "",
      razor_key: "",
      razor_order_id: "",
      razor_seceret: "",
      isSchedule: false,
      itemIdForExchangeSchedule: "",
      selectedTimeSlot: {
        is_available: "",
        slot_id: "",
        time_slot: "",
        time_slot_id: "",
        booked: false,
      },
      schedule_item_name: "",
      schedule_item_id: "",
      schedule_order_quote_id: "",
      schedule_item_image: "",
      returnProcess: false,
      order_id: "",
      schedule_text: "",
      exchange_type: "",
      orderQouteIdForReturnExchange: "",
      itemIdForReturnExchange: "",
      isSlotsActive: false,
      freeCancelMessage: "",
      timeRemaining: [{ time: null }],

      orderQouteId: null,
      interval: null,
      returnMessage: null,

      rider_detail: {
        name: "",
        number: "",
      },
      customer_detail: {
        street_address: "",
      },
      order_detail: {
        scheduled_date: "",
        shipment_status: "",
      },
      mobileTrackIcon: true,
      markerOptions: {
        url: "/img/pin-map-location.png",
        size: { width: 58, height: 50, f: "px", b: "px" },
        scaledSize: { width: 55, height: 50, f: "px", b: "px" },
      },
      isMoreOrders: true,
      isViewMore: false,
      timeSlot: [],

      returnShippingCharge: "",
      cancelPopup: false,
      cancelPayments: [],
      payment: { item: "credits" },
      ratingModel: false,
      storeRatingModel: false,
      start: "",
      end: "",
      selectedReturnPayment: "credits",
      returnType: "in_store",
      keyMap: 0,
      rating: {
        star: "",
        review: "",
        title: "",
      },
      isMap: true,
      error: "",
      center: {
        lat: parseInt(this.$root.location.lat),
        lng: parseInt(this.$root.location.long),
      },
      markers: [],
      isSource: false,
      comment: "",
      places: [],
      currentPlace: null,
      order: [],
      page: 1,
      order_quote_id: "",
      item_id: "",
      store_id: "",
      index: "",
      returnRequest: false,
      tab: 1,
      selectedReason: "",
      reasons: [],
      mainHeading: "",
      orderId: "",
      isPicked: 0,
      selectedStore: "",
      returnReasonShipping: "",
      riderName: "",
      riderNumber: "",
      slots: {
        "2021-05-12": [
          {
            is_available: false,
            slot_id: 1770,
            time_slot: "10:00 AM - 12:00 PM",
            time_slot_id: 2,
          },
        ],
      },
      selectedDate: "",
    };
  },
  filters: {
    convertTime(sec) {
      let time = "",
          min = 0,
          seconds = 0;
      if (sec != 0) {
        min = Math.floor(sec / 60);
        seconds = Math.floor(sec % 60);
      }

      return `0${min} : ${seconds > 9 ? seconds : `0${seconds}`} `;
    },
  },
  computed: {
    origin() {
      let start = {};
      start.query = this.start;
      return start;
    },
    destionation() {
      let end = {};
      end.query = this.end;
      return end;
      // return { query: this.end };
    },
    position() {
      return this.markers;
      // return { query: this.end };
    },
  },

  methods: {
    returnreplace(id){
      this.tab=id
      for(var i=0;i<this.images.length;i++){
        this.deleteimage(this.images[i].id)
      }
      this.images=[]
      this.selectedReason=''
      document.getElementById('returnexchangeimage').value=''
    },
    removeimage(id,index){
      console.log(id)
      console.log(index)
      this.images.splice(index,1)
      this.deleteimage(id)
    },
    deleteimage(id){
      let form = new FormData();
      form.append("id",id);
      axios
          .post(this.$root.cart_api + "/item/remove-image-return-exchange", form)
          .then((response) => {
            console.log(response)
          
          })
          .catch((err) => {
            console.log(err);
          });

    },
    uploadimage(value,orderId,Itemid){
 
          for(let k=0;k<value.target.files.length;k++){
            console.log(value.target.files[k].type)
             if(value.target.files[k].type == "image/jpeg" ||
                value.target.files[k].type == "image/jpg" ||
                value.target.files[k].type == "image/png" ||
                value.target.files[k].type == "image/Jpeg" ||
                value.target.files[k].type == "image/JPG" ||
                value.target.files[k].type == "image/PNG" ||
                value.target.files[k].type == "image/JPEG" ||
                value.target.files[k].type == "image/Png" ||
                value.target.files[k].type == "image/Jpg" 
                // value.target.files[k].type == "application/pdf"||
                // value.target.files[k].type == "application/PDF"
            ){
              
            }
            else{
              this.$toast.warning("ONLY PNG,JPG And JPEG ALLOWED", {
                    position: "top",
                    duration: 4000,
              });
              document.getElementById('returnexchangeimage').value=''
              value.target.files={}
                  return 1;
            }
          }
      
     if(this.images.length<5){
      this.uploadProcess=true;
     let config = { headers: { "Content-Type": "multipart/form-data" } };
      let form = new FormData();
      form.append("image",...value.target.files);
      form.append("order_quote_id",orderId);
      form.append("item_id",Itemid);
      
      axios
          .post(this.$root.cart_api + "/item/upload-image-return-exchange", form, config)
          .then((response) => {
            this.uploadProcess=false;
            document.getElementById('returnexchangeimage').value=''
            this.images.push(response.data.data)
            console.log("this.images",this.images)
          })
          .catch((err) => {
            console.log(err);
          });
     }
     else{
       this.$toast.warning("Maxmimum 5 Images Allowed", {
          position: "top",
          duration: 4000,
        });
     }
    },
    scheduleInStore(){
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      let form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("item_id", this.schedule_item_id);
      form.append(this.schedule_text, true);
      form.append("slot_id", this.selectedTimeSlot.slot_id);
      form.append("return_type", this.returnType);
      axios
          .post(this.$root.cart_api + "/item/reschedule-order", form, config)
          .then((response) => {
            if(response.data){
              window.location.reload();
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    async initPayment() {
      this.loader = true;
      this.selectTimeSlot.booked = false;
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      let form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("item_id", this.schedule_item_id);
      form.append(this.schedule_text, true);
      form.append("payment_method", "razorpay");
      form.append("slot_id", this.selectedTimeSlot.slot_id);
      form.append("return_type", this.returnType);
      await axios
          .post(this.$root.cart_api + "/item/reschedule-order", form, config)
          .then((response) => {
            console.log(response.data.data.razor_key);
            this.razor_key = response.data.data.razor_key;
            this.razor_order_id = response.data.data.razor_order_id;
            this.razor_seceret = response.data.data.razor_seceret;
            this.customer_name = response.data.data.customer_name;
            this.customer_email = response.data.data.customer_email;
            this.customer_number = response.data.data.customer_phone;
          })
          .catch((err) => {
            console.log(err);
          });

      const options = {
        key: this.razor_key,
        amount: this.rtoShippingCharger,
        name: this.schedule_item_name,
        image: `/img/fav2.ico`,
        payment_capture: 1,
        order_id: this.razor_order_id,
        handler: response => {
		  console.log(response.razorpay_payment_id);
          this.$root.page_loader = true;
          var form = new FormData();
          form.append("customer_id", this.$root.customer_id);
          form.append("customer_session", this.$root.customer_session);
          form.append("item_id", this.schedule_item_id);
          form.append("payment_status", "success");
          form.append("payment_id", response.razorpay_payment_id);

          var razorpay_order_api = "";
          razorpay_order_api = `${this.$root.cart_api}/item/reschedule-delivery`;

          fetch(razorpay_order_api, {
            method: "post",
            body: form
          })
              .then(response => response.json())
              .then(data => {
                if(data.success){
                  window.location.reload();
                };
              })
        },
        prefill: {
          name: this.customer_name,
          email: this.customer_email,
          contact: parseInt(this.customer_number),
        },
      };
      const rzp = new Razorpay(options);
      rzp.open();
	  this.loader = false;
    },
    getTimeSlotsForSchedule(item) {
      this.itemIdForExchangeSchedule = item;
      let form = new FormData();
      form.append("item_id", item);
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("schedule_exchange", true);

      axios
          .post(this.$root.cart_api + "/item/reschedule-slots", form)
          .then((response) => {
            this.isSchedule = true;
            this.slots = response.data.data.slots;
            this.getTimeSlot(Object.keys(this.slots)[0]);
          })
          .catch((error) => {
            console.log(error);
          });
    },
    handleExchangeSchedule() {
      let form = new FormData();
      form.append("slot_id", this.selectedTimeSlot.slot_id);
      form.append("time_slot_id", this.selectedTimeSlot.time_slot_id);
      form.append("time_slot", this.selectedTimeSlot.time_slot);
      form.append("time_slot_date", this.selectedDate);

      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("item_id", this.itemIdForExchangeSchedule);
      axios
          .post(this.$root.cart_api + "/item/schedule-exchange", form)
          .then(async (response) => {
            if (response.data.success) {
              this.isSchedule = false;
              this.order.map((order) => {
                if (order.item_id == this.itemIdForExchangeSchedule) {
                  order.schedule_exchange = false;
                }
                return order;
              });
              this.$toast.success(response.data.message, {
                position: "top",
                duration: 4000,
              });
            } else {
              this.$toast.error(response.data.message, {
                position: "top",
                duration: 4000,
              });
            }

            // this.slots = response.data.data;
            // this.getTimeSlot(Object.keys(this.slots)[0]);
          })
          .catch((error) => {
            console.log(error);
          });
    },
    re_order(item) {
      this.schedule_item_name = item.name;
      this.schedule_item_id = item.item_id;
      this.schedule_order_quote_id = item.order_quote_id;
      this.schedule_item_image = item.image;
      if (item.schedule_rto == true) {
        this.exchange_type = "Re-Delivery";
        this.schedule_text = "schedule_rto";
      }
      if (item.schedule_failed_exchange == true) {
        this.exchange_type = "Re-Delivery";
        this.schedule_text = "schedule_failed_exchange";
      }
      if (item.schedule_return == true) {
        this.exchange_type = "Re-Delivery";
        this.schedule_text = "schedule_return";
      }
      this.returnItem = item;
      this.returnProcess = true;
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      let form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("item_id", item.item_id);
      form.append(this.schedule_text, true);
      form.append("order_quote_id", item.order_quote_id);
      axios
          .post(this.$root.cart_api + "/item/reschedule-slots", form, config)
          .then((response) => {
            this.slots = response.data.data.slots;
            this.rtoShippingCharger = response.data.data.shippingCharge;
            this.getTimeSlot(Object.keys(this.slots)[0]);
          })
          .catch((err) => {
            console.log(err);
          });
    },
    handleClose() {
      this.returnProcess = false;
      this.returnRequest = false;
      let object = {
        is_available: "",
        slot_id: "",
        time_slot: "",
        time_slot_id: "",
      };
      this.selectedTimeSlot = object;
      this.isSlotsActive = false;

      for(var i=0;i<this.images.length;i++){
        this.deleteimage(this.images[i].id)
      }
      this.images=[]
    },
    returnExchangeSlotsHandler(order_quote_id, item_id) {
      if (this.selectedReason != "") {

        if(this.imageRequiredreasons.includes(this.selectedReason) && this.images.length==0){
          this.$toast.warning("Please Upload atleast one image", {
          position: "top",
          duration: 4000,
        });
        }
        else{
        this.orderQouteIdForReturnExchange = order_quote_id;
        this.itemIdForReturnExchange = item_id;
        this.isSlotsActive = true;
        }
      } else {
        this.$toast.warning("Please select reason", {
          position: "top",
          duration: 4000,
        });
      }
    },
    selectTimeSlot(time_slot, is_available, slot_id, time_slot_id) {
      // console.log("called selected", timeSlot, slotId, isAvailable,timeSlotId);
      let object = {
        is_available: is_available,
        slot_id: slot_id,
        time_slot: time_slot,
        time_slot_id: time_slot_id,
        booked: true
      };
      this.selectedTimeSlot = object;
      // console.log("select",this.selectedTimeSlot);
    },

    returnTimer(item) {
   
      var arr=item.order_date.split(/[- :]/)
      // var startDate = new Date(item.order_date);
      var startDate=new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
      // Do your operations
      var endDate = new Date();
      var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
      if (seconds <= 300) {
        var index = this.order.indexOf(item);

        this.timeRemaining.splice(index, 0, {
          time: Math.floor(300 - seconds),
        });
        this.order[index].showTimer = true;
        this.showTimer(index);
      }
     
    },
   
    showTimer(index) {
      this.timeRemaining[index].time -= 1;
      if (this.timeRemaining[index].time > 0) {
        setTimeout(() => {
          this.showTimer(index);
        }, 1000);
      } else {
        this.order[index].showTimer = false;
      }
    },
    trackCollaps: function () {
      this.mobileTrackIcon = !this.mobileTrackIcon;
      // some code to filter users
    },
    // findAvailableSlot() {
    // 	// console.log("this,timeslotes", this.timeSlots);
    // 	let timeslots = this.timeSlots;
    // 	let that = this;
    // 	// if(that.selectTimeSlot.length == 0){

    // 	// }
    // 	if (this.firstAvailableSlot.time_slot == undefined) {
    // 		Object.keys(timeslots).forEach(function(key) {
    // 			timeslots[key].find(e => {
    // 				if (e.is_available == true) {
    // 					that.firstAvailableSlot = e;
    // 					const index = timeslots[key].indexOf(e);

    // 					that.firstAvailableSlotIndex = index;
    // 					that.selectTimeSlot(e, index);
    // 					return e;
    // 				}
    // 			});
    // 		});
    // 	}
    // 	// this.timeSlot
    // },
    getTimeSlot(date) {
      this.selectedDate = date;
      // console.log(this.slots[date]);
      this.timeSlot = this.slots[date];
      console.log(this.timeSlot);
    },
    onChangeReason(event) {
      let reasonObj = this.reasons.find((x) => event.target.value == x.id);
      if (reasonObj) {
        if (reasonObj.free_shipping != 1) {
          // this.returnReasonShipping = 'shipping charges are applicable'
        } else {
          this.returnReasonShipping = "";
        }
      }
    },
    getRiderLocation() {
      if(this.test < 9) {
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        let form = new FormData();

        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("order_id", this.orderId);
        form.append("status", "forward");
        axios
            .post(
                this.$root.cart_api + "/order/track-order?index=" + this.test,
                form,
                config
            )
            .then((response) => {
              this.test = this.test + 1;
              // this.start = `${response.data.data.lat},${response.data.data.lng}`;
              (this.markers = {
              	position: {
              		lat: response.data.data.lat,
              		lng: response.data.data.lng
              	}
              }),
              this.end = `${response.data.data.lat},${response.data.data.lng}`;
            })
            .catch((err) => {
              console.log(err);
            });
      }
    },
    getRouteData(order_id, isPicked, riderName, riderNumber) {
      if (riderName) {
        this.riderName = riderName;
        this.riderNumber = riderNumber;
      }
      this.start = "";
      this.end = "";
      this.isPicked = isPicked;
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      let form = new FormData();

      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("order_id", order_id);
      form.append("status", "start_end");
      axios
          .post(this.$root.cart_api + "/order/track-order", form, config)
          .then((response) => {
            this.orderId = order_id;
            this.customer_detail = response.data.data.customer_data;
            this.order_detail = response.data.data.order_details;
            this.rider_detail = response.data.data.rider_details;

            this.start = `${response.data.data.customer_data.latitude},${response.data.data.customer_data.longitude}`;
            // (this.markers = {
            //   position: {
            //     lat: response.data.data.customer_data.latitude,
            //     lng: response.data.data.customer_data.longitude,
            //   },
            // }),
                (this.end = `${response.data.data.store_data.location_latitude},${response.data.data.store_data.location_longitude}`);
          })
          .then((this.isMap = false), this.keyMap++)
          .catch((err) => {
            console.log(err);
          });
    },
    mark(event) {
      let lat = event.latLng.lat();

      let lng = event.latLng.lng();
      this.markers[0].position.lat = lat;
      this.markers[0].position.lng = lng;
      this.$root.location.lat = lat;
      this.$root.location.long = lng;
    },
    // addLocation(){
    // 	 const locationButton = document.createElement("button");
    // 	locationButton.textContent = "Pan to Current Location";
    // 	  locationButton.classList.add("custom-map-control-button");
    // 	   controlDiv.appendChild(locationButton)
    // 	// map.controls[google.maps.ControlPosition.TOP_CENTER].push(locationButton);

    // },

    // receives a place object via the autocomplete component
    setPlace(place) {
      // console.log(place);
      this.$root.locationPlaceId = place.place_id;
      $cookies.set(
          window.location.hostname.substring(10, 4) + "_location_placeId",
          this.$root.locationPlaceId,
          "1y"
      );
      this.$root.location.lat = place.geometry.location.lat();
      this.$root.location.long = place.geometry.location.lng();
      this.$root.isLocation = true;

      $cookies.set(
          window.location.hostname.substring(10, 4) + "_location_lat",
          this.$root.location.lat,
          "1y"
      );
      $cookies.set(
          window.location.hostname.substring(10, 4) + "_location_long",
          this.$root.location.long,
          "1y"
      );
      this.currentPlace = place;
    },

    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    storeRatingModelOpen(msku, vid, id, orderQouteId) {
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.storeRatingModel = true;
        this.master_sku = msku;
        this.pro_id = vid;
        this.selectedStore = id;
        this.orderQouteId = orderQouteId;
      } else {
        this.$root.login_popup = true;
      }
    },
    ratingModelOpen(msku, vid, id, orderQouteId) {
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.ratingModel = true;
        this.master_sku = msku;
        this.pro_id = vid;
        this.selectedStore = id;
        this.orderQouteId = orderQouteId;
      } else {
        this.$root.login_popup = true;
      }
    },
    store_review(e) {
      // console.log("this.$root,this.$root", this.$root.cart_api);

      e.preventDefault();
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("master_sku", this.master_sku);
        form.append("store_id", this.selectedStore);
        form.append("product_id", this.pro_id);
        form.append("order_quote_id", this.orderQouteId);
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("title", this.rating.title);
        form.append("review", this.rating.review);
        form.append("rating", this.rating.star);

        let config = { headers: { "Content-Type": "multipart/form-data" } };
        axios
            .post(this.$root.cart_api + "/store/add-rating", form, config)
            .then((response) => {
              this.$root.page_loader = false;
              if (response.data.success == true) {
                this.$toast.success(response.data.message, {
                  position: "top",
                  duration: 4000,
                });
                this.rating.title = "";
                this.rating.star = "";
                this.rating.review = "";
                this.storeRatingModel = false;
              } else {
                this.$toast.error(response.data.message, {
                  position: "top",
                  duration: 4000,
                });
                if (response.data.customer_session_status == false) {
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_customer",
                      "",
                      "1y"
                  );
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cs",
                      "",
                      "1y"
                  );
                  this.$root.customer_id = "";
                  this.$root.customer_session = "";
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      "",
                      "1y"
                  );
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_carts",
                      "",
                      "1y"
                  );
                  this.$root.pcart = "";
                  this.$root.cart_session = "";
                  this.$root.cart_product = [];
                  this.$router.push("/login.html");
                }
              }
            })
            .catch((error) => {
              this.$root.page_loader = false;
            });
      } else {
        this.$root.login_popup = true;
      }
    },
    customer_review(e) {
      // console.log("customer_review", this.mainHeading);
      e.preventDefault();

      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("master_sku", this.master_sku);
        form.append("store", this.selectedStore);
        form.append("product_id", this.pro_id);
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        // form.append("title", this.rating.title);
        form.append("description", this.rating.review);
        form.append("rating", this.rating.star);
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        axios
            .post(this.$root.cart_api + "/review/add-review", form, config)
            .then((response) => {
              this.$root.page_loader = false;
              if (response.data.success == true) {
                this.$toast.success(response.data.message, {
                  position: "top",
                  duration: 4000,
                });
                this.rating.title = "";
                this.rating.star = "";
                this.rating.review = "";
                this.ratingModel = false;
              } else {
                this.$toast.error(response.data.message, {
                  position: "top",
                  duration: 4000,
                });
                if (response.data.customer_session_status == false) {
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_customer",
                      "",
                      "1y"
                  );
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cs",
                      "",
                      "1y"
                  );
                  this.$root.customer_id = "";
                  this.$root.customer_session = "";
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      "",
                      "1y"
                  );
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_carts",
                      "",
                      "1y"
                  );
                  this.$root.pcart = "";
                  this.$root.cart_session = "";
                  this.$root.cart_product = [];
                  this.$router.push("/login.html");
                }
              }
            })
            .catch((error) => {
              this.$root.page_loader = false;
            });
      } else {
        this.$root.login_popup = true;
      }
    },
    cancel_order() {
      // console.log(this.store_id);
      let form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("item_id", this.item_id);
      form.append("order_id", this.order_quote_id);
      if (this.cancelPayments.length > 0) {
        form.append("refund_method", this.payment.item);
      } else {
        form.append("refund_method", null);
      }

      form.append("store", this.store_id);
      this.$root.page_loader = true;
      axios
          .post(this.$root.cart_api + "/order/cancel", form)
          .then((res) => {
            if (res.data.success) {
              this.$root.page_loader = false;
              // console.log("called");

              this.order[this.index].order_status = "cancelled";
              this.cancelPopup = false;
              this.$toast.warning("Order cancelled successfully", {
                position: "top-right",
                duration: 4000,
              });
            } else {
              this.$root.page_loader = false;
              this.$toast.error(res.data.message, {
                position: "top-right",
                duration: 4000,
              });
            }
          })
          .catch((e) => {
            this.$root.page_loader = false;
            this.$toast.error("Something went wrong.", {
              position: "top-right",
              duration: 4000,
            });
          });
    },

    getVariations(product) {
      // console.log("getVariations", product);
      this.$root.page_loader = true;
      axios
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: "product_variation_options",
              // store: this.$root.store,
              group_id: product.group_id,
              id_product: product.id_product,
              source_product_id: product.source_product_id,
              store: product.store,
              url_key: product.url_key,
              sort_by: this.pass_sort,
              sort_dir: this.sort_dir,
              filter: this.apifilter,
              latitude: 28.5758268,
              longitude: 77.3209443,
            },
          })
          .then((response) => {
            // console.log("getVariations", response.data.result);
            this.productVariation = response.data.result.variations;
            this.$root.page_loader = false;
            // console.log(seeOtherBuyingOptions);
          })
          .catch((error) => {
            this.$root.page_loader = false;
          });
    },
    order_return_open(item) {
      // console.log("called",item);
      this.returnItem = item;
      // console.log("this.returnItem =", this.returnItem);

      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("type", "return");
      form.append("oi", item.order_quote_id);
      form.append("ii", item.item_id);
      form.append("sku", item.sku);
      form.append("gi", item.group_id);
      form.append("store_id", item.store_id);

      form.append("customer_session", this.$root.customer_session);
      axios
          .post(this.$root.cart_api + "/item/return-exchange-reasons", form)
          .then((response) => {
            this.storeName=response.data.data.store_name;
            this.storeAddress=response.data.data.store_address;
            this.reasons = response.data.data.reasons;
             this.reasons.forEach(element => {
               if(element.image_required){
                 this.imageRequiredreasons.push(element.id)
               }
             });
            
            this.slots = response.data.data.slots;
            this.getTimeSlot(Object.keys(this.slots)[0]);
            this.returnMessage = response.data.data.message;

            this.returnShippingCharge = response.data.data.shippingCharge;
            this.isSource = response.data.data.source;
            // if (this.reasons.length > 0) {
            // 	this.selectedReason = this.reasons[0].id;
            // }
          });
      this.returnRequest = true;
      //this.getVariations(item);
    },
    order_exchange_open(item) {
      // console.log("called",item);
      this.returnItem = item;
      // console.log("this.returnItem =", this.returnItem);

      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("type", "exchange");
      form.append("oi", item.order_quote_id);
      form.append("ii", item.item_id);
      form.append("sku", item.sku);
      form.append("gi", item.group_id);
      form.append("store_id", item.store_id);

      form.append("customer_session", this.$root.customer_session);
      axios
          .post(this.$root.cart_api + "/item/return-exchange-reasons", form)
          .then((response) => {
            console.log(response);
            this.reasons = response.data.data.reasons;
            this.returnMessage = response.data.data.message;
            this.storeName=response.data.data.store_name;
            this.storeAddress=response.data.data.store_address;
            this.returnShippingCharge = response.data.data.shippingCharge;
            this.isSource = response.data.data.source;
            // if (this.reasons.length > 0) {
            // 	this.selectedReason = this.reasons[0].id;
            // }
          });
      this.returnRequest = true;
      //this.getVariations(item);
    },
    order_return: function () {
      // console.log("this.selectedReason", this.selectedReason);
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.page_loader = true;
        this.$root.error_message = "";
        this.$root.success_message = "";
        var form = new FormData();
        form.append("slot_id", this.selectedTimeSlot.slot_id);
        form.append("time_slot_id", this.selectedTimeSlot.time_slot_id);
        form.append("time_slot", this.selectedTimeSlot.time_slot);
        form.append("time_slot_date", this.selectedDate);
        form.append("return_type", this.returnType);
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("order_id", this.orderQouteIdForReturnExchange);
        form.append("item_id", this.itemIdForReturnExchange);
        form.append("rr", this.selectedReason);
        form.append("source", this.selectedReturnPayment);
        form.append("comment", this.comment);

        axios
            .post(this.$root.cart_api + "/item/return", form)
            .then((response) => {
              if (response.data.success === true) {
                this.$root.page_loader = false;
                this.latestorder = response.data.data;
                this.return_popup = false;
                this.$router.go();
              } else {
                this.$root.page_loader = false;
                this.$root.error_message = response.data.message;
                 this.$toast.warning(response.data.message, {
                position: "top",
                duration: 4000,
              });
              }
            })
            .catch((error) => {
              this.$root.page_loader = false;
              if (error.message === "Network Error") {
                this.$root.error_message = error.message;
              }
              else{
                this.$toast.warning(error.message, {
                position: "top",
                duration: 4000,
              });
              }
              // window.scrollTo(0, 0);
            });
      }
    },
    order_return_new: function (order_id,item_id) {
    
      if (this.selectedReason != "") {
        this.orderQouteIdForReturnExchange = order_id;
        this.itemIdForReturnExchange = item_id;
        // this.isSlotsActive = true;
      } else {
        this.$toast.warning("Please select reason", {
          position: "top",
          duration: 4000,
        });
        return true;
      }

      if(this.imageRequiredreasons.includes(this.selectedReason) && this.images.length==0){
        this.$toast.warning("Please Upload atleast one image", {
          position: "top",
          duration: 4000,
        });
        return true;
      }
     
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.page_loader = true;
        this.$root.error_message = "";
        this.$root.success_message = "";
        var form = new FormData();
        form.append("slot_id", this.selectedTimeSlot.slot_id);
        form.append("time_slot_id", this.selectedTimeSlot.time_slot_id);
        form.append("time_slot", this.selectedTimeSlot.time_slot);
        form.append("time_slot_date", this.selectedDate);
        form.append("return_type", this.returnType);
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        // form.append("order_id", this.orderQouteIdForReturnExchange);
        // form.append("item_id", this.itemIdForReturnExchange);
        form.append("order_id", order_id);
        form.append("item_id", item_id);
        form.append("rr", this.selectedReason);
        form.append("source", this.selectedReturnPayment);
        form.append("comment", this.comment);

        axios
            .post(this.$root.cart_api + "/item/return", form)
            .then((response) => {
              if (response.data.success === true) {
                this.$root.page_loader = false;
                this.latestorder = response.data.data;
                this.return_popup = false;
                this.$router.go();
              } else {
                this.$root.page_loader = false;
                this.$root.error_message = response.data.message;
                
                this.$toast.warning(response.data.message, {
                position: "top",
                duration: 4000,
              });
              }
            })
            .catch((error) => {
              console.log(error)
              this.$root.page_loader = false;
              if (error.message === "Network Error") {
                this.$root.error_message = error.message;
              }
              
              // window.scrollTo(0, 0);
            });
      }
    },
    exchange() {
      // console.log("called");
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.page_loader = true;
        this.$root.error_message = "";
        this.$root.success_message = "";
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("slot_id", this.selectedTimeSlot.slot_id);
        form.append("time_slot_id", this.selectedTimeSlot.time_slot_id);
        form.append("time_slot", this.selectedTimeSlot.time_slot);
        form.append("time_slot_date", this.selectedDate);
        form.append("customer_session", this.$root.customer_session);
        form.append("order_id", this.orderQouteIdForReturnExchange);
        form.append("item_id", this.itemIdForReturnExchange);
        form.append("return_type", this.returnType);
        form.append("rr", this.selectedReason);
        form.append("comment", this.comment);
        axios
            .post(this.$root.cart_api + "/item/exchange", form)
            .then((response) => {
              if (response.data.success === true) {
                this.$root.page_loader = false;
                this.latestorder = response.data.data;
                this.return_popup = false;
                this.$router.go();
              } else {
                this.$root.page_loader = false;
                this.$root.error_message = response.data.message;
                this.$toast.warning(response.data.message, {
                  position: "top",
                  duration: 4000,
                });
              }
            })
            .catch((error) => {
              this.$root.page_loader = false;
              if (error.message === "Network Error") {
                this.$root.error_message = error.message;
              }
              // window.scrollTo(0, 0);
            });
      }
    },
    exchange_new(orderId,itemId) {
     if (this.selectedReason != "") {
        this.orderQouteIdForReturnExchange = orderId;
        this.itemIdForReturnExchange = itemId;
        // this.isSlotsActive = true;
      } else {
        this.$toast.warning("Please select reason", {
          position: "top",
          duration: 4000,
        });
        return true;
      }

      if(this.imageRequiredreasons.includes(this.selectedReason) && this.images.length==0){
        this.$toast.warning("Please Upload atleast one image", {
          position: "top",
          duration: 4000,
        });
        return true;
      }
     
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.page_loader = true;
        this.$root.error_message = "";
        this.$root.success_message = "";
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("slot_id", this.selectedTimeSlot.slot_id);
        form.append("time_slot_id", this.selectedTimeSlot.time_slot_id);
        form.append("time_slot", this.selectedTimeSlot.time_slot);
        form.append("time_slot_date", this.selectedDate);
        form.append("customer_session", this.$root.customer_session);
        form.append("order_id", orderId);
        form.append("item_id", itemId);
        form.append("return_type", this.returnType);
        form.append("rr", this.selectedReason);
        form.append("comment", this.comment);
        axios
            .post(this.$root.cart_api + "/item/exchange", form)
            .then((response) => {
              if (response.data.success === true) {
                this.$root.page_loader = false;
                this.latestorder = response.data.data;
                this.return_popup = false;
                this.$router.go();
              } else {
                this.$root.page_loader = false;
                this.$root.error_message = response.data.message;
                this.$toast.warning(response.data.message, {
                  position: "top",
                  duration: 4000,
                });
              }
            })
            .catch((error) => {
              this.$root.page_loader = false;
              if (error.message === "Network Error") {
                this.$root.error_message = error.message;
              }
              // window.scrollTo(0, 0);
            });
      }
    },
    reorder(pcart) {
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("pcart", pcart);
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      axios
          .post(this.$root.cart_api + "/order/re-order", form)
          .then((response) => {
            if (response.data.success === true) {
              $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.data.pcart
              );
              $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  response.data.data.cart_session
              );
              this.$root.cart_session = response.data.data.cart_session;
              this.$root.pcart = response.data.data.pcart;
              this.$root.thankyou_cart = response.data.data.pcart;
              this.$router.push("checkout.html");
              this.$root.page_loader = false;
            } else {
              window.scrollTo(0, 0);
              this.$root.page_loader = false;
              this.$root.error_message = response.data.message;
              if (response.data.customer_session_status == false) {
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_customer",
                    "",
                    "1y"
                );
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cs",
                    "",
                    "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    "",
                    "1y"
                );
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_carts",
                    "",
                    "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/");
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                  "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
    },
    order_with_cod(pcart) {
      this.$root.page_loader = true;
      this.$root.thankyou_cart = pcart;
      var form = new FormData();
      this.$root.thankyou_status = true;
      $cookies.set(
          window.location.hostname.substring(10, 4) + "_thank",
          "true"
      );
      form.append("pcart", pcart);
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      axios
          .post(this.$root.cart_api + "/order/cod-confirmation", form)
          .then((response) => {
            if (response.data.success === true) {
              $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.data.pcart
              );
              $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  response.data.data.cart_session
              );
              this.$root.cart_session = response.data.data.cart_session;
              this.$root.pcart = response.data.data.pcart;
              this.$root.thankyou_cart = response.data.data.pcart;
              this.$router.push("thankyou.html");
            } else {
              this.$root.page_loader = false;
              this.$root.error_message = response.data.message;
              this.$root.thankyou_status = false;
              $cookies.set(
                  window.location.hostname.substring(10, 4) + "_thank",
                  ""
              );
              if (response.data.customer_session_status == false) {
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_customer",
                    "",
                    "1y"
                );
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cs",
                    "",
                    "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    "",
                    "1y"
                );
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_carts",
                    "",
                    "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/");
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            this.$root.thankyou_status = false;
            $cookies.set(
                window.location.hostname.substring(10, 4) + "_thank",
                ""
            );
            if (error.message === "Network Error") {
              this.$root.error_message =
                  "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
    },
    get_orders: function () {
      this.$root.page_loader = true;
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.error_message = "";
        this.$root.success_message = "";
        // this.$root.page_loader = true;
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("store", this.$root.store);
        this.isViewMore = true;
        axios
            .post(
                this.$root.cart_api + "/customer/get-orders?page=" + this.page,
                form
            )
            .then((response) => {
              if (response.data.success === true) {
                this.isViewMore = false;
                this.$root.page_loader = false;
                if (response.data.data.length == 0) {
                  this.isMoreOrders = false;
                }
                // this.order.concat(response.data.data)
                this.order = [...this.order, ...response.data.data];
                this.order.forEach((x) => {
                  x.showTimer = false;
                  this.returnTimer(x);
                });
                this.page = this.page + 1;
                // this.order = response.data.data;
              } else {
                this.isViewMore = false;
                this.$root.page_loader = false;
                this.$root.error_message = response.data.message;
                if (response.data.customer_session_status == false) {
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_customer",
                      "",
                      "1y"
                  );
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cs",
                      "",
                      "1y"
                  );
                  this.$root.customer_id = "";
                  this.$root.customer_session = "";
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      "",
                      "1y"
                  );
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_carts",
                      "",
                      "1y"
                  );
                  this.$root.pcart = "";
                  this.$root.cart_session = "";
                  this.$root.cart_product = [];
                  this.$router.push("/");
                }
              }
              this.orderLoader = false;
            })
            .catch((error) => {
              this.isViewMore = false;
              this.$root.page_loader = false;
              if (error.message === "Network Error") {
                this.$root.error_message = error.message;
              }
              window.scrollTo(0, 0);
            });
      }
    },

    orderCancelModal(
        order_quote_id,
        item_id,
        store_id,
        i,
        freeCancel = false,
        payments
    ) {
      if (!freeCancel) {
        this.freeCancelMessage =
            "This order is already under process and cancelling would attract a restocking charge. Are you sure you want to cancel this order?";
      } else {
        this.freeCancelMessage = "";
      }
      if (order_quote_id) {
        this.order_quote_id = order_quote_id;
        this.item_id = item_id;
        this.store_id = store_id;
        this.index = i;
        this.cancelPayments = payments;
        // this.payment = payments[0]
      }
      this.cancelPopup = !this.cancelPopup;
    },
  },
  beforeMount() {
    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode == 27) {
        this.isSchedule = false;
        this.returnRequest = false;
        this.storeRatingModel = false;
        this.ratingModel = false;
      }
    });
  },
  mounted() {
    this.$root.page_loader = true ;
    // setInterval(()=>{
    // 	this.markers = 	{

    // 				position: {
    // 				lat: parseInt(28.6494),
    // 				lng: parseInt(77.1437),

    // 				}
    // 			}
    // },5000)
    this.get_orders();
  },
  watch: {
    isMap(newVal) {
      if (newVal === false) {
        this.interval = setInterval(() => this.getRiderLocation(), 6000);
      } else {
        clearInterval(this.interval);
      }
    },
  },
  created() {
    // if (this.isPicked == 1) {
    // 	this.interval = setInterval(() => this.getRiderLocation(), 6000);
    // }

    window.scrollTo(0, 0);
    if (this.$root.customer_id === null || this.$root.customer_id === "") {
      this.$router.push("/");
    }
    (this.$root.error_message = ""),
    (this.$root.success_message = ""),
    (this.$root.breadcrumb = "My Order");
    // (this.$root.page_loader = false);
  },
};
</script>
<style>
.product-images{
  margin-top:15px;
  margin-bottom:15px;
}
.product-thumbnail{
  display:flex;
   flex-direction: row;
   flex-wrap: wrap;
}
.thumbnail-remove-button{
      border: 1px solid var(--main-color);
   background-color: white;
    font-family: 'lhmSemiBold' !important;
    outline: none !important;
    cursor: pointer;
}
.thumbnail-remove-button:hover{
  color:white;
  background-color: var(--main-color);
}
.thumbnail{
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.thumb-img{
  border: 1px solid #ddd; /* Gray border */
  border-radius: 4px;  /* Rounded border */
  padding: 5px; /* Some padding */
  width: 150px; /* Set a small width */
 
}
.cursorNotAlllowed{
  cursor: not-allowed;
}
.orderPageSkeleton .Skeleton1 , .orderPageSkeleton .Skeleton2 {
  display: block;
  height: 200px;
  width: 97%;
  margin: 30px auto;
}
.image-progress-bar{
  text-align:center;
}
</style>